var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 27098",
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39614",
    clipPath: "url(#star_filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17513",
    d: "M31.922 12.1a1.5 1.5 0 00-1.2-1.007L21.5 9.685 17.358.863a1.5 1.5 0 00-2.716 0L10.5 9.685l-9.227 1.409a1.5 1.5 0 00-.847 2.53l6.721 6.89-1.589 9.744a1.5 1.5 0 002.206 1.555L16 27.26l8.236 4.553a1.5 1.5 0 002.206-1.555l-1.59-9.744 6.721-6.89a1.5 1.5 0 00.349-1.523",
    fill: "currentColor"
  }))));
}
export default SvgStarFilled;